import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import styled from 'styled-components'

export const CustomAudio = styled.audio<{ theme: string }>`
  ::-webkit-media-controls-enclosure {
    background-color: var(--gray-200);
  }

  ::-webkit-media-controls-panel {
    filter: ${({ theme }) => (theme === ThemeMode.DARK ? 'invert(1)' : 'none')};
  }
`

CustomAudio.displayName = 'CustomAudio'
